/* eslint-disable import/no-anonymous-default-export */
import { SET_PROFILE_USER } from "./actionTypes";

const initialState: any = {
  userId:null,
  name: null,
  email: null,
  companies: null,
  currentRole: null,
  currentCompany: null,
  heading: null,
  passwordExpiresAt: null,
};

export default (state: any = initialState, action: any) => {
  switch (action.type) {
    case SET_PROFILE_USER:
      return {
        ...state,
        userId:action.payload.id,
        name: action.payload.name,
        email: action.payload.email,
        roles: action.payload.roles,
        companies: action.payload.companies,
        currentRole: action.payload.currentRole,
        currentCompany: action.payload.currentCompany,
        heading: action.payload.heading,
        passwordExpiresAt: action.payload.passwordExpiresAt,
      };
    default:
      return {
        ...state,
      };
  }
};
